import { useTranslation } from 'react-i18next';

interface TagProps {
	type: 'unique' | 'new' | 'owned';
}

export const Tag: React.FC<TagProps> = ({ type }: TagProps) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Template
	**********************/
	return (
		<span
			className={`text-[8px] leading-1 shadow-lg bg-gradient-to-r rounded-lg px-2 text-center mx-1 text-gray-800 leading-none py-[2px] font-semibold ${
				type === 'unique'
					? ' from-purple-400 via-purple-500 to-purple-600'
					: type === 'new'
					? 'from-orange-400 via-yellow-500 to-yellow-600'
					: type === 'owned'
					? 'from-green-400 via-green-500 to-green-600'
					: ''
			}`}
		>
			{type === 'unique' && 'Unique'}
			{type === 'new' && 'New'}
			{type === 'owned' && t('alreadyOwned')}
		</span>
	);
};
